"use strict";

var _regeneratorRuntime = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@netgum/utils");

var AccountPayment = /*#__PURE__*/function () {
  function AccountPayment(apiMethods, contract, device, state) {
    _classCallCheck(this, AccountPayment);

    this.apiMethods = apiMethods;
    this.contract = contract;
    this.device = device;
    this.state = state; //
  }

  _createClass(AccountPayment, [{
    key: "createAccountPayment",
    value: function createAccountPayment(recipient, token, value) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var accountAddress, payment;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                accountAddress = this.state.accountAddress;
                _context.next = 3;
                return this.apiMethods.createAccountPayment(accountAddress, recipient, token, value);

              case 3:
                payment = _context.sent;

                if (!(payment && recipient)) {
                  _context.next = 8;
                  break;
                }

                _context.next = 7;
                return this.signAccountPayment(payment);

              case 7:
                payment = _context.sent;

              case 8:
                return _context.abrupt("return", payment);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "signAccountPayment",
    value: function signAccountPayment(payment) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var accountAddress, hash, value, recipient, token, address, message, signature;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                accountAddress = this.state.accountAddress;
                hash = payment.hash, value = payment.value, recipient = payment.recipient, token = payment.token;
                address = this.contract.virtualPaymentManager.address;
                message = utils_1.abiEncodePacked('address', 'address', 'address', 'address', 'bytes', 'uint256')(address, accountAddress, recipient.address || recipient.account.address, token && token.address ? token.address : utils_1.ZERO_ADDRESS, hash, value);
                signature = this.device.signPersonalMessage(message);
                return _context2.abrupt("return", this.apiMethods.signAccountPayment(accountAddress, hash, signature));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }]);

  return AccountPayment;
}();

exports.AccountPayment = AccountPayment;